import React from 'react';

interface TestModalProps {
    isOpen: boolean;
    onClose: () => void;
}

const TestModal: React.FC<TestModalProps> = ({ isOpen, onClose }) => {
    console.log('TestModal rendu avec isOpen:', isOpen);

    if (!isOpen) return null;

    return (
        <div
            style={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                background: 'rgba(0, 0, 0, 0.5)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                zIndex: 9999
            }}
            onClick={onClose}
        >
            <div
                style={{
                    background: 'white',
                    padding: '20px',
                    borderRadius: '8px',
                    maxWidth: '400px',
                    width: '90%'
                }}
                onClick={(e) => e.stopPropagation()}
            >
                <h2>Test Modal</h2>
                <p>Si vous voyez ceci, la modal fonctionne !</p>
                <button onClick={onClose}>Fermer</button>
            </div>
        </div>
    );
};

export default TestModal;
